// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

.font-dropdown_mod-menu-item_ONiSM {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0 -0.25rem;
  min-width: 6.25rem;
  padding: calc(2 * 0.25rem);
  padding-left: calc(3 * 0.25rem);
  padding-right: calc(3 * 0.25rem);
  width: 8.5rem;
  cursor: pointer;
  -webkit-transition: 0.1s ease;
  transition: 0.1s ease;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  overflow-wrap: anywhere;
}

.font-dropdown_mod-menu-item_ONiSM:hover {
  background: var(--paint-looks-secondary, #855cd6);
  color: white;
}

.font-dropdown_mod-context-menu_b3uwS {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
      -ms-flex-direction: column;
          flex-direction: column;
}

.font-dropdown_mod-unselect_cALos {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.font-dropdown_displayed-font-name_GbVIu {
  font-size: 0.8rem;
  overflow: hidden;
  white-space: nowrap;
}

.font-dropdown_font-dropdown_Sn1Nk {
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  color: var(--paint-text-primary, #575e75);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 1rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
  width: 8.5rem;
  height: 2rem;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/font-dropdown/font-dropdown.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;EAC3B,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;MAC1B,0BAA0B;UACtB,sBAAsB;AAChC;;AAEA;EACE,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;EAC3B,yCAAyC;EACzC,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,sCAAsC;MAClC,sBAAsB;UAClB,8BAA8B;EACtC,aAAa;EACb,YAAY;AACd","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n.mod-menu-item {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 -0.25rem;\n  min-width: 6.25rem;\n  padding: calc(2 * 0.25rem);\n  padding-left: calc(3 * 0.25rem);\n  padding-right: calc(3 * 0.25rem);\n  width: 8.5rem;\n  cursor: pointer;\n  -webkit-transition: 0.1s ease;\n  transition: 0.1s ease;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  overflow-wrap: anywhere;\n}\n\n.mod-menu-item:hover {\n  background: var(--paint-looks-secondary, #855cd6);\n  color: white;\n}\n\n.mod-context-menu {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.mod-unselect {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.displayed-font-name {\n  font-size: 0.8rem;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.font-dropdown {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: var(--paint-text-primary, #575e75);\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1rem;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 8.5rem;\n  height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mod-menu-item": `font-dropdown_mod-menu-item_ONiSM`,
	"modMenuItem": `font-dropdown_mod-menu-item_ONiSM`,
	"mod-context-menu": `font-dropdown_mod-context-menu_b3uwS`,
	"modContextMenu": `font-dropdown_mod-context-menu_b3uwS`,
	"mod-unselect": `font-dropdown_mod-unselect_cALos`,
	"modUnselect": `font-dropdown_mod-unselect_cALos`,
	"displayed-font-name": `font-dropdown_displayed-font-name_GbVIu`,
	"displayedFontName": `font-dropdown_displayed-font-name_GbVIu`,
	"font-dropdown": `font-dropdown_font-dropdown_Sn1Nk`,
	"fontDropdown": `font-dropdown_font-dropdown_Sn1Nk`
};
export default ___CSS_LOADER_EXPORT___;
